import { __decorate } from "tslib";
import { Component, Mixins, Prop } from 'vue-property-decorator';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
let TopNavSubMenu = class TopNavSubMenu extends Mixins(ViewportSizeMixin) {
    get subMenuLinks() {
        return [
            {
                title: 'Resources',
                link: 'https://www.youtube.com/channel/UCfI5QDh8PmAiU0outNApCkA',
                external: true,
            },
            {
                title: 'ChatGenie Expert Assistance',
                link: `/sales-partner`,
                external: false,
            },
            {
                title: 'Become a Sales Partner',
                link: `/sales-partner/get-started`,
                external: false,
            },
            {
                title: 'Blog',
                link: `https://blog.chatgenie.ph/`,
                external: true,
            },
        ];
    }
    get displayHomeNav() {
        return this.$store.state.displayHomeNav;
    }
    goTo(link, isExternal) {
        if (isExternal) {
            window.open(link);
        }
        else {
            this.$router.push(link);
        }
    }
};
__decorate([
    Prop({ type: Boolean, default: false })
], TopNavSubMenu.prototype, "whiteLabeled", void 0);
TopNavSubMenu = __decorate([
    Component
], TopNavSubMenu);
export default TopNavSubMenu;
